import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from '../../MaterialIcon';
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import axios from "axios";
import {showToastForBackend} from "../../../actions/toastActions";
import PanelLayout from "../components/PanelLayout";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import ToggleMaxResultBox from "../components/ToggleMaxResultBox";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import {FormattedMessage} from "react-intl";

class CustomPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customLogics: [],
            chosenLogic: "",
            configParam: ""
        };
        this.getCustomLogicList = this.getCustomLogicList.bind(this);
    }


    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.chosenLogic) {
            this.setState({chosenLogic: this.props.clickedNodeInfo.extras.options.chosenLogic}, () => {
            });
        }
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.configParam) {
            this.setState({configParam: this.props.clickedNodeInfo.extras.options.configParam}, () => {
            });
        }
        this.getCustomLogicList();
    }

    getCustomLogicList() {
        axios.get(this.props.properties.logicUrl + "/custom", axiosConfig())
            .then((response) => {
                this.setState(() => ({
                    customLogics: response.data
                }));
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                } else {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    updateOptions() {
        const {chosenLogic, configParam} = this.state;
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options = {chosenLogic, configParam};
        this.props.clickedNodeAction(panelInfo);
    }

    onLogicSelectedChange(event) {
        this.setState({chosenLogic: event.target.value},
            () => {
                this.updateOptions()
            })
    }

    handleConfigParamChange(event) {
        this.setState({configParam: event.target.value},
            () => {
                this.updateOptions()
            })
    }

    render() {
        return (
            <PanelLayout className="custom-panel">
                <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <form className="input-container">
                                <div className="form-select">
                                    {!this.props.hideArrow &&
                                        <span className="arrow"><MaterialIcon icon="keyboard_arrow_down"
                                                                              size={24}/></span>}
                                    <select onChange={(event) => this.onLogicSelectedChange(event)}
                                            value={this.state.chosenLogic ? this.state.chosenLogic : ""}>
                                        {this.state.chosenLogic === "" ?
                                            <option value="" disabled>Please select...</option> : null}
                                        {this.state.customLogics.length > 0 ?
                                            this.state.customLogics.map((x, index) =>
                                                <option key={index} value={x.configName}>{x.readableName}</option>) :
                                            <option value="" disabled>No available options</option>}
                                    </select>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ToggleMaxResultBox/>
                <ContentWithTopLabel label="Configuration">
                    <FormattedMessage id="Enter configuration parameters">
                        {placeholder =>
                        <textarea name="configContent"
                                  className="configuration-textarea"
                                  placeholder={placeholder}
                                  onChange={event => this.handleConfigParamChange(event)}
                                  value={this.state.configParam}/>
                        }
                    </FormattedMessage>
                </ContentWithTopLabel>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        modal: state.modalInfo.modal,
        content: state.modalInfo.content,
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {hideModal, showToastForBackend, clickedNodeAction})(CustomPanel);